import * as React from 'react';
import {CustomField, CustomButton, Loader} from 'components/index';
import {Form, Formik, FormikActions} from "formik";
import {STORE_UI, STORE_ADMIN, VALIDATION_RULES} from "appConstants";
import {inject, observer} from "mobx-react";
import {UIStore, AdminStore} from "stores";
import classNames from "classnames";
import {RouteComponentProps} from "react-router";
import UpdatePaychainAdminInput from "graphql/mutations/inputs/UpdatePaychainAdminInput";
import {AdminModel} from "graphql/models/admin";
import * as Yup from "yup";
import styles from './EditSuperAdminModal.module.scss';

interface FormValues {
  firstName: string;
  lastName: string;
  email: string;
}

export interface Props extends RouteComponentProps<any> {
  [STORE_UI]: UIStore;
  [STORE_ADMIN]: AdminStore;
  onCancel: () => void;
  superAdminData: AdminModel;
}

const VALIDATION_SCHEMA = Yup.object().shape({
  firstName: VALIDATION_RULES.firstName,
  lastName: VALIDATION_RULES.lastName,
});

@inject(STORE_UI, STORE_ADMIN)
@observer

export default class EditSuperAdminModal extends React.Component <Props, {}> {

  componentDidMount(): void {
    this.props[STORE_ADMIN].clearErrorMsg();
  }

  onSubmit = async ({ firstName, lastName }: FormValues, actions: FormikActions<FormValues>) => {
    this.props[STORE_UI].setLoadModalData();
    actions.setStatus();

    const superAdminData: UpdatePaychainAdminInput = {
      id: this.props.superAdminData.id,
      firstName: firstName,
      lastName: lastName
    };

    await this.props[STORE_ADMIN].updateSuperAdmin(superAdminData);
    this.props[STORE_UI].setLoadModalData(false);

    if(this.props[STORE_ADMIN].fetchError){
      actions.setStatus({ fetchError: this.props[STORE_ADMIN].fetchError })
    } else {
      this.props.onCancel();
    }
  };

  render() {
    const {firstName, lastName, email} = this.props.superAdminData;
    return (
      <Formik
        initialValues={{firstName, lastName, email}}
        validationSchema={VALIDATION_SCHEMA}
        onSubmit={this.onSubmit}
      >{ form => {
        const isDisabled = !form.dirty || !form.isValid;
        return <Form>
          <div className={classNames(styles.cPopupContent, styles.minHeight)}>
            <div>
              <div className={styles.cControlsLeft}>
                <CustomField
                  name="firstName"
                  title="First name"
                  placeholder="Enter first name..."
                  form={form}
                  autoFocus
                  className={styles.leftPosition}
                  onChange={form.handleChange}
                  onBlur={form.handleBlur}
                  onKeyDown={(e:KeyboardEvent)=>{this.props[STORE_UI].handleFormKeyPress(e, form)}}
                />
                <CustomField
                  name="lastName"
                  title="Last name"
                  placeholder="Enter last name..."
                  form={form}
                  className={styles.leftPosition}
                  onChange={form.handleChange}
                  onBlur={form.handleBlur}
                  onKeyDown={(e:KeyboardEvent)=>{this.props[STORE_UI].handleFormKeyPress(e, form)}}
                />
              </div>

              <div className={styles.cControlsLeft}>
                <CustomField
                  disabled={true}
                  name="email"
                  title="Email"
                  placeholder="Enter email..."
                  form={form}
                  className={styles.leftPosition}
                  onChange={form.handleChange}
                  onBlur={form.handleBlur}
                  onKeyDown={(e:KeyboardEvent)=>{this.props[STORE_UI].handleFormKeyPress(e, form)}}
                />
                <div className={styles.leftPosition} />
              </div>
              {form.status && <p className={styles.serverError}>{form.status.fetchError}</p>}
            </div>

            <div className={styles.cButtonRight}>
              {this.props[STORE_UI].loadModalData?<Loader className={styles.loader}/>:
                <CustomButton size={"xxs"} type="submit" buttonType="primary" disabled={isDisabled}>Save</CustomButton>
              }
            </div>
          </div>
        </Form>}}
      </Formik>
    );
  }
}
